import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Collector } from "../../../../core/models/users/collectors/collectorDto";
import { UserHeader } from "../../../../core/models/users/user-header";
import { TableModule } from "primeng/table";
import { CommonModule } from "@angular/common";
import { InputTextModule } from "primeng/inputtext";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";

@Component({
  selector: "jni-collector-listing",
  templateUrl: "./collector-listing.component.html",
  imports: [
    TableModule,
    CommonModule,
    InputTextModule,
    ButtonModule,
    CardModule,
  ],
  styleUrls: ["./collector-listing.component.scss"],
})
export class CollectorListingComponent {
  @Input() parent!: FormGroup;
  @Input() CollectorListing!: Collector[];
  @Output() updateUser = new EventEmitter<UserHeader>();

  onEditRow(event: UserHeader) {
    event.userType = "Collector";
    this.updateUser.emit(event);
  }
}
